import React, { memo, useContext, useCallback } from 'react';
import { View, FlatList } from 'react-native';
import { isAfter, parseISO } from 'date-fns';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { Button } from 'design-system/Button';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { DateFilterContext } from './context';
import SelectorWithButtons from '../analyticsFilter/SelectorWithButtons';
import { monthsArr, filterStartYear } from './constants';
import { isWeb } from '../../constants';
const MonthlyContent = () => {
    const styles = useStyles(styleSet);
    const { currentYear, selectedYear, selectedMonth, setSelectedYear, setSelectedMonth, todayDateStr, } = useContext(DateFilterContext);
    const changeYear = useCallback((decrease) => () => {
        if (decrease) {
            if (selectedYear > filterStartYear) {
                setSelectedYear(selectedYear - 1);
            }
            return;
        }
        if (selectedYear < currentYear) {
            setSelectedYear(selectedYear + 1);
        }
    }, [currentYear, selectedYear, setSelectedYear]);
    return (<View style={styles.container}>
      <Spacer h={16}/>
      <SelectorWithButtons title={selectedYear} onForward={changeYear(false)} onBackward={changeYear(true)} disableForward={selectedYear === currentYear} disableBackward={selectedYear === filterStartYear}/>
      <FlatList numColumns={isWeb ? 4 : 3} data={monthsArr} scrollEnabled={false} contentContainerStyle={styles.contentContainerStyles} columnWrapperStyle={styles.columnWrapperStyle} renderItem={({ item, index }) => (<View style={styles.eachButtonContainer}>
            <Button flex square title={item} disabled={selectedYear === currentYear &&
                isAfter(new Date(selectedYear, index, 1), parseISO(todayDateStr))} containerStyle={styles.buttonStyles} onPress={() => setSelectedMonth(index)} {...(selectedMonth === index
            ? { brandTextBorder: true }
            : { gray: true })}/>
          </View>)}/>
    </View>);
};
export default memo(MonthlyContent);
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingTop: rem(8),
        backgroundColor: colors.background.light,
    },
    columnWrapperStyle: {
        flex: 1,
    },
    eachButtonContainer: {
        flex: 1,
        margin: rem(8),
        height: rem(45),
    },
    contentContainerStyles: {
        padding: rem(8),
    },
    buttonStyles: {
        height: rem(45),
    },
}));
